
var React = require("react");

class AssetAction extends React.Component  {

    render(){
        const { 
            style,
            onClick,
            Content
        } = this.props;
 
        return <div style={style} onClick={onClick}><Content/></div>
    }
}

module.exports = AssetAction;
